<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span v-if="convenio"
                        >Ofício de Encerramento -
                        {{ convenio.vcCodigoEstruturado }}</span
                    >
                </h4>
                <div class="mb-4" v-if="modeloPadrao">
                    <h5>
                        <span class="text-primary">Campos disponíveis</span>
                    </h5>
                    <strong>{{ modeloPadrao.objeto }}</strong>
                </div>
                <div class="mb-4" v-if="modeloPadrao">
                    <h5><span class="text-primary">Modelo Padrão</span></h5>
                    Arquivo: <strong>{{ modeloPadrao.nomeArquivo }}</strong>
                    <div class="mt-2 d-flex flex-row">
                        <btn-download-modelo
                            class="mr-2"
                            :modelo="modeloPadrao"
                            tipoDocumento="oficioencerramento"
                        ></btn-download-modelo>
                        <btn-upload-modelo
                            class="mr-2"
                            tipo="padrao"
                            @obterAtualizacao="
                                obterConvenioOficioEncerramento()
                            "
                            tipoDocumento="oficioencerramento"
                        ></btn-upload-modelo>
                        <btn-download-documento
                            :modelo="modeloPadrao"
                            :convenio="convenio"
                            tipoDocumento="oficioencerramento"
                        ></btn-download-documento>
                    </div>
                </div>
                <div class="mb-4" v-if="modeloPadrao">
                    <h5><span class="text-primary">Modelo Convênio</span></h5>
                    <div v-if="modeloConvenio">
                        Arquivo:
                        <strong>{{ modeloConvenio.nomeArquivo }}</strong>
                    </div>
                    <div class="mt-2 d-flex flex-row">
                        <btn-download-modelo
                            class="mr-2"
                            v-if="modeloConvenio"
                            :modelo="modeloConvenio"
                            tipoDocumento="oficioencerramento"
                        ></btn-download-modelo>
                        <btn-upload-modelo
                            class="mr-2"
                            tipo="convenio"
                            @obterAtualizacao="
                                obterConvenioOficioEncerramento()
                            "
                            tipoDocumento="oficioencerramento"
                        ></btn-upload-modelo>
                        <btn-download-documento
                            v-if="modeloConvenio"
                            :modelo="modeloConvenio"
                            :convenio="convenio"
                            tipoDocumento="oficioencerramento"
                        ></btn-download-documento>
                    </div>
                </div>
                <app-btn-voltar></app-btn-voltar>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnDownloadModelo from '../componentes/BtnDownloadModelo'
import BtnUploadModelo from '../componentes/BtnUploadModelo'
import BtnDownloadDocumento from '../componentes/BtnDownloadDocumento'

export default {
    components: {
        BtnDownloadModelo,
        BtnUploadModelo,
        BtnDownloadDocumento
    },

    data() {
        return {
            convenio: null,
            modeloPadrao: null,
            modeloConvenio: null
        }
    },

    methods: {
        obterConvenioOficioEncerramento() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterConvenioDocumentoModelos(
                this.$route.params.convenioId,
                'oficioencerramento'
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.convenio = response.data.convenio
                        this.modeloPadrao = response.data.modeloPadrao
                        this.modeloConvenio = response.data.modeloConvenio
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterConvenioOficioEncerramento()
    }
}
</script>
